import React, { useEffect, useState } from "react";
import UserScreenWindow from "../Components/UserScreenWindow";
import PageModal from "../../Dashboard/Components/PageModal";
import CarStickerApplicationWithNotification from "./CarStickerApplicationWithNotification";
import {
  getAllDocsSnap,
  queryAllDocsByFieldSnap,
} from "../../../utils/firebase/Firebase.utils";
import { useSelector } from "react-redux";
import CarStickerCard from "./CarStickerCard";
import { Link } from "react-router-dom";

export default function CarStickerPage() {
  const currentUser = useSelector((state) => state.userObject);
  const [addMode, setAddMode] = React.useState(false);
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchApplications = async () => {
      await queryAllDocsByFieldSnap(
        "carStickers",
        "userId",
        "==",
        currentUser.uid,
        (data) => {
          setApplications(data);
          setLoading(false);
        }
      );
    };
    fetchApplications();
  }, []);

  return (
    <UserScreenWindow label="Car Sticker Applications">
      <div className="header">Car Sticker Application Page</div>
      <div>
        <button className="blue-button" onClick={() => setAddMode(true)}>
          New Application
        </button>
      </div>

      {loading ? (
        <div>Loading...</div>
      ) : (
        <div className="mt-4">
          {applications.map((application, index) => (
            <Link to={`/car-sticker/${application.id}`} key={index}>
              <CarStickerCard application={application} />
            </Link>
          ))}
        </div>
      )}

      {addMode && (
        <PageModal>
          <CarStickerApplicationWithNotification setAddMode={setAddMode} />
        </PageModal>
      )}
    </UserScreenWindow>
  );
}
